// Components==============
import { faArrowAltToBottom } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import Modal from '../Modal';
import RichText from '../RichText';
import './index.module.scss';
// =========================

const ConditionalLink = ({ to, children, accentColor }) => {
    if (to.includes('http'))
        return (
            <a
                href={to}
                style={{ background: accentColor || '' }}
                styleName="wrapper"
                target="_blank"
                rel="noreferrer"
            >
                {children}
            </a>
        );

    return (
        <NavLink to={to} styleName="wrapper">
            {children}
        </NavLink>
    );
};

const Link = ({ text, to, accentColor }) => (
    <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
        <ConditionalLink accentColor={accentColor} to={to}>
            {text}
        </ConditionalLink>
    </motion.div>
);

const Popup = ({ popup, text, popupAccent, hide }) => {
    const openUrlModal = useOpenUrlModal(`normal-button-popup/${text}`);

    return (
        <>
            {hide === true ? null : (
                <motion.button
                    styleName="wrapper"
                    type="button"
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    onClick={openUrlModal}
                >
                    <span>{text}</span>
                </motion.button>
            )}
            <AnimatePresence>
                <Modal color={popupAccent} slug={`normal-button-popup/${text}`}>
                    <div styleName="popup-wrapper">
                        <RichText accent={popupAccent} richText={popup} />
                    </div>
                </Modal>
            </AnimatePresence>
        </>
    );
};

const File = ({ file, text, accentColor }) => (
    <motion.a
        style={{ background: accentColor || '' }}
        href={`/storage/${file}`}
        download
        styleName="wrapper"
        type="button"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
    >
        <FontAwesomeIcon icon={faArrowAltToBottom} /> {text}
    </motion.a>
);

export default function NormalButton({
    text,
    type,
    to,
    file,
    popup,
    popupAccent,
    accentColor,
    hide,
}) {
    if (type === 'popup')
        return (
            <Popup
                popup={popup}
                hide={hide}
                text={text}
                popupAccent={popupAccent}
            />
        );

    if (type === 'file')
        return <File accentColor={accentColor} file={file} text={text} />;

    return <Link accentColor={accentColor} to={to} text={text} />;
}
